<template>
    
<div v-if="dissave"  style="position:absolute; top: 300px;   width: 100%; z-index:100;  ">
  <Circle4 size="120px" class="mx-auto"></Circle4>
</div>


<div>
            <h2 class="text-center text-primary">Шумораи аҳолӣ аз рӯи нафақа</h2>
<div class="row">
<div class="col-3">

    <h3 class="text-center">Минтақа</h3>

    <div class="list-group">
 
    <button  v-for="t in this.$store.state.ter" :key="t" @click="refresh(t.Terid)" class="list-group-item list-group-item-action @ViewBag.act0">{{t.NameTJ}} </button>
 
 
    </div>
</div>

<div class="col-9">

<!--
<p>
    <input type="button" value="Экспорт ба Excel" class="btn btn-primary" onclick="exportReportToExcel()" />
    <input type="button" value="Чопкунӣ" class="btn btn-primary" onclick="imprimir()" />
</p>
-->




<table class="table table-hover table-bordered table-striped" id="tabdata1">
    <thead>
        <tr>
            <th class="text-center">
                Намуди нафақа
            </th>
            <th class="text-center">
                Ҳамагӣ
            </th>
            <th class="text-center">
                Мардҳо
            </th>
            <th class="text-center">
                Занҳо
            </th>
         
        </tr>
    </thead>
    <tbody>
       
            <tr v-for="r in list" :key="r">
                <td>
                    {{r.Name}}
                </td>
                <td>
                    {{r.c01}}
                </td>
                <td>
                    {{r.c02}}
                </td>
                <td>
                    {{r.c03}}
                </td>
    
            </tr>
         
    </tbody>
</table>
 
</div>
</div></div>
</template>



<script>
 

export default {

data(){

    return{
        list:'',
        dissave:false,
        name:'',
        surname:''


    }
},

 methods:{

async GetReport(terid){
    this.dissave=true;
console.log('start report3');
try{
                    await this.$api("/api/summary/"+6+"/"+terid+" /")
                  //  .then(res => res.json())
                    .then(data => this.list=data)
                    .catch(error => {
                          console.error("There was an error!", error)
                    });

                    console.log('stop report3');
}
catch(ex){
console.log(ex);

}
finally{
console.log('finish');

}
this.dissave=false;
},

refresh(h){

 

this.GetReport(h);

}


},

mounted(){

    this.GetReport(this.$store.state.terid);
}



}
</script>
